import { render, staticRenderFns } from "./Kegiatan.vue?vue&type=template&id=64b16363"
import script from "./Kegiatan.vue?vue&type=script&lang=js"
export * from "./Kegiatan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports